module.exports = __webpack_public_path__ + "img/large-01.de5f97b0.jpg";